import React from 'react';
import PropTypes from 'prop-types';

import { graphql } from 'gatsby';
import SingleWpContentTemplate from '../SingleWpContentTemplate';

const SingleBlogPostTemplate = ({ data, pageContext }) => {
  // Take the modified content during build
  return (
    <SingleWpContentTemplate
      post={data.wpPost}
      previousItem={pageContext?.previousItem?.node}
      toc={data.wpPost.tableOfContent}
      nextItem={pageContext?.nextItem?.node}
      latestBlogposts={pageContext?.latestBlogposts}
      latestPodcasts={pageContext?.latestPodcasts}
      relatedPosts={pageContext.relatedPosts.map(post => post.node)}
    />
  );
};

SingleBlogPostTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default SingleBlogPostTemplate;

export const postQuery = graphql`
  query($id: String!) {
    wpPost(id: { eq: $id }) {
      content
      tableOfContent {
        url
        title
        items {
          url
          title
          items {
            url
            title
          }
        }
      }
      date(formatString: "MMM DD, YYYY")
      modified(formatString: "MMM DD, YYYY")
      excerpt
      seo {
        canonical
        metaDesc
        focuskw
        metaKeywords
        title
      }
      title
      date(formatString: "MMM DD, YYYY")
      slug
      desiredSlug
      tags {
        nodes {
          slug
          name
        }
      }
      featuredImage {
        node {
          mediaItemUrl
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
      }
      status
      categories {
        nodes {
          name
          slug
          id
        }
      }
    }
  }
`;
